export default "__VITE_ASSET__CQs07Q5j__"